<template>
  <div class="couponContent" ref="appContainer">
    <el-form label-position="right" label-width="100px">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="SPU ID">
                <el-input v-model="couponForm.spuIds" clearable>
                  <el-button slot="append" @click="showSpuDialog">批量</el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="货号">
                <el-input clearable v-model='couponForm.designerId'></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="颜色">
                <el-input clearable v-model='couponForm.colorCode'></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="商品名称">
                <el-input clearable v-model='couponForm.spuName'></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="季节">
                <el-select clearable v-model='couponForm.seasonCodes' multiple>
                  <el-option v-for='(item, index) in seasonCodeList' :key='index' :label='item.label'
                    :value='item.value'>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="品牌">
                <el-select clearable v-model='couponForm.brandIds' multiple filterable>
                  <el-option v-for='(item, index) in brandList' :key='index' :label='item.label' :value='item.value'>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="上架状态">
                <el-select multiple clearable v-model='couponForm.statusList'>
                  <el-option v-for='(item, index) in saleStatusList' :key='index' :label='item.label'
                    :value='item.value'>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="制作类型">
                <el-select clearable v-model='couponForm.spuEditType'>
                  <el-option v-for='(item, index) in spuEditList' :key='index' :label='item.label' :value='item.value'>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="是否禁售">
                <el-select clearable v-model='couponForm.banSale'>
                  <el-option v-for='(item, index) in banSaleList' :key='index' :label='item.label' :value='item.value'>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="买手店">
                <el-select clearable filterable v-model='couponForm.vendorIds' multiple>
                  <el-option v-for='(item, index) in vendorList' :key='index' :label='item.label' :value='item.value'>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="SPU创建时间">
                <el-date-picker style="width: 100%" v-model="rangeDate" type="datetimerange" :clearable="true"
                  value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" format="yyyy-MM-dd"
                  range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="类目">
                <el-cascader v-model="couponForm.categoryIds" collapse-tags :options="categoryList" :props="optionProps"
                  :style="{ width: '100%' }" clearable></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
          <el-button @click="onSearch(true)" type="primary">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-col>
      </el-row>
    </el-form>

    <section class="ticketLogContent">
      <div class="btnContent">
        <el-button @click="batchAdd(null)" size="small"> 全部加入</el-button>
        <el-button @click="batchQuite(null)" size="small"> 全部退出</el-button>
      </div>

      <el-table :data="couponTableData" @selection-change="handleSelectionChange" v-loading="tableLoading" border>
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column label="" width="50" class-name="nopadding">
          <template slot-scope="scope">
            <list-img :img="scope.row.coverImg" :width="30"></list-img>
          </template>
        </el-table-column>
        <el-table-column label="SPU ID">
          <template slot-scope="scope">
            <a target='_blank' :href="'#/platGoods/spuInfo/' + scope.row.spuId">{{ scope.row.spuId }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="designerId" label="货号"> </el-table-column>
        <el-table-column prop="colorCode" label="颜色"> </el-table-column>
        <el-table-column prop="spuName" label="商品名称"> </el-table-column>
        <el-table-column prop="seasonCode" label="季节"> </el-table-column>
        <el-table-column width="200" prop="categoryName" label="类目"> </el-table-column>
        <el-table-column prop="brandName" label="品牌"> </el-table-column>
        <el-table-column prop="statusName" label="上架状态"> </el-table-column>
        <el-table-column prop="spuEditTypeName" label="制作类型"> </el-table-column>
        <el-table-column width="130" prop="onSaleSellerCount" label="在售个卖商家数"> </el-table-column>
        <el-table-column prop="topSpuStatusName" label="商品池状态"> </el-table-column>
        <el-table-column prop="" label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.topSpuStatus == 1" @click="batchAdd(scope.row.spuId)" type="text" size="small">加入
            </el-button>
            <el-button v-if="scope.row.topSpuStatus == 2" @click="batchQuite(scope.row.spuId)" type="text" size="small">
              退出</el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>

    <section class="marketPagination" :style="'width:' + paginationWidth + 'px'">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="searchQuery.pageNo" :page-sizes="pageSizeArr" :page-size="searchQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="totalSize"></el-pagination>
    </section>

    <el-dialog title="批量SPU查询" :visible.sync="dialogVisible" :close-on-click-modal="false" custom-class="spu-dialog"
      width="30%">
      <p>请输入SPU ID(一行一个，最多1000个)</p>
      <el-alert v-if="dialogErrorText" :title="dialogErrorText" type="error">
      </el-alert>
      <el-input type="textarea" :rows="6" placeholder="请输入内容" v-model="dialogSpuText">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDialog">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import ListImg from '../shared/ListImg.vue';
import { getBrandList, getSeasonList, getCategory, getManagerList, getVendorList, addSpuManager, delSpuManager, checkSpuIds } from './api';
export default {
  components: {
    ListImg,
  },
  data() {
    return {
      vendorList: [],//买手店列表
      categoryList: [],
      seasonCodeList: [],//季节列表
      brandList: [],//品牌列表
      banSaleList: [{ //是否禁售
        value: 0,
        label: '否'
      }, {
        value: 1,
        label: '是'
      }],
      saleStatusList: [{ //上架状态列表
        value: 1,
        label: 'ON SELL'
      }, {
        value: 2,
        label: 'OFF SALE'
      }, {
        value: 3,
        label: 'SOLD OUT'
      }],
      spuEditList: [{
        value: 1,
        label: '一次编辑'
      }, {
        value: 2,
        label: '二次编辑'
      }],
      topSpuStatusList: [{
        value: 1,
        label: '未加入'
      }, {
        value: 2,
        label: '已加入'
      }],
      rangeDate: [],
      couponTableData: [],
      multiplelist: [],
      consultantList: [{
        value: 1,
        label: 222
      }],
      couponForm: {
        spuIds: "",
        designerId: "",
        colorCode: "",
        spuName: "",
        seasonCodes: [],
        categoryIds: [],
        brandIds: [],
        statusList: [],
        spuEditType: '',
        banSale: 0,
        vendorIds: [],
        // topSpuStatus:1 //加入状态
      },
      couponFormRules: {

      },
      searchQuery: {
        pageNo: 1,
        pageSize: 50
      },
      pageSizeArr: [25, 50, 200, 500],
      totalSize: 0,
      paginationWidth: 0,
      tableLoading: false,
      confirmBtnLoading: false,
      dialogVisible: false,
      dialogSpuText: '',
      dialogErrorText: '',
      optionProps: {
        expandTrigger: "hover",
        emitPath: false,
        checkStrictly: false,
        multiple: true
      },
    }
  },
  mounted() {
    this.setWidth()
    this.initSearchList()

    // this.getRecordList();
  },
  methods: {
    async selectActiveCategorys() { //获取商品类目树
      try {
        let resData = (await getCategory({includeUnisex: false})).data;
        console.error(resData, 're')
        this.categoryList = Object.freeze(this.gatherCategory(resData));
      } catch (err) {
        this.$message.error(err);
      }
    },
    gatherCategory(items) {
      if (Array.isArray(items)) {
        return items.map(item => {
          let newItem = {
            label: item.chineseName,
            value: item.categoryId
          };
          if (Array.isArray(item.children)) {
            newItem.children = this.gatherCategory(item.children);
          }
          return newItem;
        });
      } else {
        return items;
      }
    },
    initSearchList() {

      getBrandList().then(res => {//获取品牌列表
        this.brandList = (res.data || []).map(item => {
          return {
            label: item.englishName,
            value: item.brandId
          };
        });
      });
      getSeasonList().then((res) => { //获取季节列表
        this.seasonCodeList = (res.data || []).map(item => {
          return {
            label: item.seasonCode,
            value: item.seasonCode
          }
        })
      });

      this.selectActiveCategorys()
      getVendorList().then(res => {
        this.vendorList = (res.data || []).map(item => {
          return {
            value: item.vendorId,
            label: item.vendorName
          }
        })
      })
      this.getManagerList(true)
    },
    batchAdd(spuId) { //全部加入

      if (spuId) {
        this.selectSpuList = [spuId]
        console.error(this.selectSpuList, 'this.selectSpuList')
      } else if (!this.multiplelist || this.multiplelist.length == 0) {
        this.$message.error('请选择！')
        return false
      } else {
        this.selectSpuList = this.multiplelist.map(item => item.spuId)
      }
      if (spuId) {
        addSpuManager({
          spuIds: this.selectSpuList
        }).then(res => {
          if (res && res.success) {
            if (res.data && res.data.length > 0) {
              if (spuId) { //单个加入
                if (res.data.length == 1) {
                  this.$message.error('当前SPU无尺码，加入失败');
                  return false;
                }
              } else { //批量加入
                let msg = '以下SPU无尺码，加入失败\n' + res.data.join(',');
                this.$message.error(`${msg}`)
              }
            } else {
              this.$message.success('加入成功')
              this.getManagerList()
            }
          } else {
            this.$message.error(`${res.message}`)

          }
        })
      } else {
        this.$confirm("是否确认加入选中的所有商品?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(res => {

          addSpuManager({
            spuIds: this.selectSpuList
          }).then(res => {
            if (res && res.success) {
              if (res.data && res.data.length > 0) {
                if (spuId) { //单个加入
                  if (res.data.length == 1) {
                    this.$message.error('当前SPU无尺码，加入失败');
                    return false;
                  }
                } else { //批量加入
                  let msg = '以下SPU无尺码，加入失败\n' + res.data.join(',');
                  this.$message.error(`${msg}`)
                }
              } else {
                this.$message.success('加入成功')
                this.getManagerList()
              }
            } else {
              this.$message.error(`${res.message}`)

            }
          })

        })

      }



    },
    batchQuite(spuId) { //全部退出
      if (spuId) {
        this.selectSpuList = [spuId]
        console.error(this.selectSpuList, 'this.selectSpuList')
      } else if (!this.multiplelist || this.multiplelist.length == 0) {
        this.$message.error('请选择！')
        return false
      } else {
        this.selectSpuList = this.multiplelist.map(item => item.spuId)
      }
      if (spuId) {
        delSpuManager({
          spuIds: this.selectSpuList
        }).then(res => {
          console.error(res, 'sss')
          if (res && res.success) {
            this.$message.success('退出成功')
            this.getManagerList()
          }
        })
      } else {
        this.$confirm("是否确认退出选中的所有商品?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(res => {
          delSpuManager({
            spuIds: this.selectSpuList
          }).then(res => {
            console.error(res, 'sss')
            if (res && res.success) {
              this.$message.success('退出成功')
              this.getManagerList()
            }
          })
        })
      }


    },
    setWidth() {
      //设置底部分页宽度
      let fn = () => {
        let width = this.$refs.appContainer && this.$refs.appContainer.offsetWidth
        this.paginationWidth = width
        return fn
      }
      window.addEventListener('resize', fn())
    },
    async getManagerList(isReset) {
      this.tableLoading = true
      if (isReset) {
        this.searchQuery.pageNo = 1
      }
      let searchQuery = this.searchQuery
      try {
        // console.log(88888,searchQuery)
        console.error(this.rangeDate, searchQuery, 'rrrrlist')
        let startCreatedAt, endCreatedAt;
        if (this.rangeDate && this.rangeDate.length > 0) {
          [startCreatedAt, endCreatedAt] = this.rangeDate
        }

        let spuIds = this.couponForm.spuIds ? (this.couponForm.spuIds.includes(',') ? this.couponForm.spuIds.split(',') : this.couponForm.spuIds.split('，')) : [];
        let resData = await getManagerList(this.formatQuery({ ...searchQuery, ...this.couponForm, startCreatedAt, endCreatedAt, spuIds }));
        let result = resData.data;
        this.tableLoading = false
        this.couponTableData = ((result && result.list) || []).map(item => {
          return {
            ...item,
            spuEditTypeName: (this.spuEditList.find(v => v.value == item.spuEditType) || {}).label,
            statusName: (this.saleStatusList.find(v => v.value == item.status) || {}).label,
            topSpuStatusName: (this.topSpuStatusList.find(v => v.value == item.topSpuStatus) || {}).label,
          }
        })
        this.totalSize = resData.data && resData.data.total
      } catch (err) {
        this.tableLoading = false
      }
    },
    handleSizeChange(val) {
      this.searchQuery.pageNo = 1
      this.searchQuery.pageSize = val
      this.getManagerList()
    },
    handleCurrentChange(val) {
      this.searchQuery.pageNo = val
      this.getManagerList()
    },
    async handleClick(bloggerId) {
      console.log(133, bloggerId)
      const res = await api.deleteBlogger({ bloggerId: bloggerId })
      console.log(137, res)
      if (res && res.status == 1) {
        this.$message.success('删除成功')
        this.getRecordList(true)
      } else {
        this.$message.success(res.data || '删除失败')
      }
    },
    submitDialog() {
      // console.error(this.dialogSpuText,'text')
      this.dialogErrorText = '';
      let dialogSpuText = this.dialogSpuText;
      let spuList = dialogSpuText.split('\n').filter(item => item != '')
      if (!dialogSpuText || spuList && spuList.length == 0) {
        this.dialogErrorText = '请输入平台商品编号'
        return false;
      }
      if (spuList.some(item => !(/(^[1-9]\d*$)/.test(item)))) {
        this.dialogErrorText = 'SPUID 只能输入正整数'
        return false;
      }
      if (spuList.length > 1000) {
        this.dialogErrorText = '输入行不允许超过一千'
        return false;
      }
      checkSpuIds({
        spuIds: spuList
      }).then(res => {
        console.error(res, 'submit')
        console.error(spuList, 'rrrr')
        if (res && res.success) {
          if (res.data && res.data.length > 0) {
            this.dialogErrorText = '含有不存在的商品平台编号 (SPU ID)\n' + res.data.join(',');
            //  if(spuList.length==1){
            //    this.dialogErrorText = '含有不存在的商品平台编号(SPU ID)'
            //  }else{
            //     this.dialogErrorText = '以下SPU无尺码，加入失败\n'+res.data.join(',')
            //  }
          } else {
            this.$message.success('添加成功');
            this.dialogVisible = false;
            this.couponForm.spuIds = spuList.join(',')
          }
        } else {
          this.$message.error(`${res.message}`)
        }
      })


    },
    resetForm() {
      this.rangeDate = []
      this.couponForm.spuIds = '';
      this.$refs["couponForm"].resetFields();
    },
    onSearch(isReset) {
      this.getManagerList(isReset)
    },
    handleSelectionChange(val) {
      console.error(val, 'vvv')
      this.multiplelist = val

    },
    showSpuDialog() {
      this.dialogVisible = true;
      this.dialogErrorText = '';
      this.dialogSpuText = '';
    },
    formatQuery(obj) {
      for (let [key, value] of Object.entries(obj)) {
        if (value === '' || value && value.length == 0 || value === undefined || value === null) {
          delete obj[key]
        }
      }
      return obj
    }
  },

}
</script>
<style lang="less" >
.spu-dialog {
  .el-dialog__body {
    padding: 10px 20px !important;
  }

  .el-alert {
    margin: 10px 0;
    padding: 5px;
  }
}

.couponContent {
  padding: 20px 50px 50px 50px;

  .el-button--small {
    padding: 12px 10px;
  }

  .couponForm {
    // width: 400px;
  }

  .el-form--inline .el-form-item {
    // width: 310px;
  }

  .marketPagination {
    background: white;
    position: fixed;
    bottom: 0;
    text-align: right;
    padding-right: 60px;
    z-index: 999;
  }

  .btnContent {
    margin-bottom: 20px;
  }
}
</style>
